import type { FC } from 'react';
import type { TableColumn } from '@interstate/components/Table';
import { Table } from '@interstate/components/Table';
import type { IAuditLogChange, IDealChangeRecord } from '@makemydeal/dr-platform-types';
import { Box } from '@interstate/components/Box';
import { transformation } from '../Transformation';
import { ChangesWrapper, TimelineSidebar, TableWrapper } from './ChangeInAllVersionList.style';

const NestedChangeLogTable: FC<{
    data: Array<IAuditLogChange & { key: string }>;
    handleSetSlideoutProps: (selectedItem: IDealChangeRecord) => void;
}> = ({ data, handleSetSlideoutProps }) => {
    const changes = data || [];
    const columnNestedDefs: TableColumn[] = [
        {
            dataIndex: 'date',
            title: 'Modified Date',
            render: (value) => transformation.transformationDateTime(value)
        },
        {
            dataIndex: 'displayName',
            title: 'Field Name',
            render: (_, record) => transformation.transformationFieldName(record)
        },
        {
            dataIndex: 'previousValue',
            title: 'Old Value',
            render: (_, record) =>
                transformation.transformArrayValue(
                    record.previousValue,
                    {
                        onArrayClick: () => {
                            // Handle click on previous value array
                            handleSetSlideoutProps(record);
                        }
                    },
                    record.fieldPath
                )
        },
        {
            dataIndex: 'currentValue',
            title: 'New Value',
            render: (_, record) =>
                transformation.transformArrayValue(
                    record.currentValue,
                    {
                        onArrayClick: () => {
                            // Handle click on current value array
                            handleSetSlideoutProps(record);
                        }
                    },
                    record.fieldPath
                )
        },
        {
            dataIndex: 'modifiedBy',
            title: 'Modified By',
            render: (value) => transformation.transformationModifiedBy(value)
        }
    ];

    return (
        <ChangesWrapper>
            <TimelineSidebar>
                {changes.map((_, index) => (
                    <>
                        {index === 0 && <Box key="dot-start" className="timeline-dot timeline-dot-start" />}
                        <Box
                            key={index}
                            className="timeline-dot"
                            sx={{
                                top: `${index * 4 + 4}rem`
                            }}
                        />
                    </>
                ))}
            </TimelineSidebar>
            <TableWrapper>
                <Table
                    data-testid="change-log-in-all-versions-table"
                    className="change-log-in-all-versions-table"
                    columns={columnNestedDefs}
                    data={changes}
                    bordered={true}
                />
            </TableWrapper>
        </ChangesWrapper>
    );
};

export default NestedChangeLogTable;
